export const RegexValidators = {
    HAS_LATIN_CHARS_SPACES_AND_NUMBERS: /^[ A-Za-z0-9]*$/,
    HAS_DIGIT: /\d/,
    HAS_ONLY_DIGITS: /^\d*$/,
    HAS_ONLY_DIGITS_AND_NOT_WHOLE_NUMBERS: /^\d*[.,]?\d*$/,
    HAS_ONLY_DIGITS_NEGATIVE_DIGITS_AND_NOT_WHOLE_NUMBERS: /^[-]?\d*[.,]?\d*$/,
    HAS_LOWER_CASE_LETTERS: /[a-z]/,
    HAS_UPPER_CASE_LETTERS: /[A-Z]/,
    HAS_SYMBOL: /[!@#$%^&*(),.?":{}|<>]/,
    HAS_NO_SPACE: /^(\s+\S+\s*)*(?!\s).*$/,
    HAS_NO_ANY_SPACES: /^\S*$/,
    HAS_NO_SPACE_AT_START_AND_AT_END: /^\S$|^\S[ \S]*\S$/,
    HAS_LATIN_CHARACTERS_AND_SPACES: /^[a-zA-Z\s]*$/,
    IS_PHONE_VALID: /^\d{3}-\d{3}-\d{3}$/,
    IS_IBAN: /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/,
    HAS_LETTERS_AND_NUMBERS: /^[A-Za-z0-9]+$/,
    IS_EMAIL_VALID: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    UUID_VALIDATOR: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89ABab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/,
    IBAN_VALIDATOR: /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/,
    HAS_ONLY_ALPHANUMERIC_CHARS: /^[0-9A-Za-z]+$/,
    HAS_ONLY_POSITIVE_NUMBERS: /^(\d+(\.\d+)?|\.?\d+)?$/,
    HH_MM_TIME_FORMAT: /^([01]?\d|2[0-3])?(:([0-5]?\d?)?)?$/,
    GE_PHONE_NUMBER: /^(?:\+9955\d{8}|9955\d{8}|5\d{8})$/,
    DOTTED_PAIR_NUMBER_FORMAT: /^\d{0,2}(\.\d{0,2}){0,1}(\.\d{0,2}){0,1}$/,
    MOBILE_APP_VERSION_REGEX: /^(?!\.)(\d{1,3})((\.\d{1,3})|\d{0,3}){0,1}(\.\d{0,3}){0,1}$/,
    ONLY_NUMERIC_CHARS_AND_PERIODS: /[^0-9.]/g,
    HAS_DOT_COM: /\.com\/(.*)/,
    IS_FILE_PICTURE: /\.(png|jpg|jpeg|gif|bmp|webp|svg)$/i,
    IS_SUPPORTED_BY_EMBED: /\.(pdf|mp4|webm|mp3|ogg|svg|html?)$/i,
    IS_VALID_PHONE: /^(\d{9}|)$/,
    IS_FILE_BROWSER_SUPPORTED: /\.(png|jpg|jpeg|gif|bmp|webp|svg|heif|mp4|webm|mp3|ogg|wav|pdf|html|json|txt)$/i,
    HAS_GEORGIAN_PHONE_PREFIX: /^(\+?995)/,
    ZEROES_AFTER_DOT_IN_DECIMAL: /^0+/,
    NUMBER_STARTS_WITH_ZERO: /^0[0-9]/,
};
//# sourceMappingURL=regexValidators.js.map